import copy from "clipboard-copy";
import map from "lodash/map";
import React from "react";
import { withTranslation } from "react-i18next";
import submit from "submit-form";
import useClickOutside from "../../../hooks/useClickOutside";
import DropdownIconsCheck from "../../../parts/inputs/dropdown-icons-check";
import ConnectedAccountModal from "../../../parts/modals/ConnectedAccountModal";
import SvgIcon from "../../../parts/SvgIcon";
import ToolTip from "../../../parts/tooltip";
import { RillContext } from "../../../rill/RillReact/share/base";
import scriptLoader from "../../../utils/scriptLoader";
import CycleCard from "../all-templates/components/CycleCardCP";
import EmptyStoreState from "./components/EmptyStoreState";
import ManageCategories from "./components/ManageCategories";
import SubHeader from "./components/SubHeader";

const StorefrontLinks = ({
  state,
  setState,
  pushUrl,
  pressUrl,
  pushSubdomain,
  copyText,
  toolTipTextPush,
  toolTipTextPress,
  t,
}) => {
  const dropdownRef = React.useRef(null);
  useClickOutside(
    dropdownRef,
    () => {
      setState({
        openedStoreDropdown: false,
      });
    },
    state.openedStoreDropdown
  );
  const handleOpen = (e) => {
    e.preventDefault();
    setState({
      openedStoreDropdown: !state.openedStoreDropdown,
    });
  };
  return (
    <details role="list" open ref={dropdownRef} data-align-right>
      <summary onClick={handleOpen}>
        {t("store.storefrontLinks.title")}
        <SvgIcon
          src={
            state.openedStoreDropdown
              ? "/img/new-icons/arrow-square-up.svg"
              : "/img/new-icons/arrow-square-down.svg"
          }
        />
      </summary>
      <ul role="listbox" className={state.openedStoreDropdown ? "opened" : ""}>
        <li>
          <div className="flex justify-between items-center gap-2 w-full">
            <div>
              <p className="p1">{t("store.storefrontLinks.pushStorefront")}</p>
              <p className="p1 text-(--information)">
                {`${pushSubdomain}.programs.app`}
              </p>
            </div>
            <ToolTip
              id="img-copy-push-subdomain"
              body={toolTipTextPush}
              hintClassNames={"img-copy-store"}
            >
              <button
                data-button-type="secondary"
                data-icon
                data-icon-only
                onClick={async () => {
                  await copy(pushUrl);
                  copyText("subdomain");
                }}
                type="button"
              >
                <img src="/img/new-icons/copy.svg" alt="copy" />
              </button>
            </ToolTip>
          </div>
        </li>
        <li>
          <div className="flex justify-between items-center gap-2 w-full">
            <div>
              <p className="p1">{t("store.storefrontLinks.pressStorefront")}</p>
              <p className="p1 text-(--information)">
                {`${pushSubdomain}.gymmembership.app`}
              </p>
            </div>
            <ToolTip
              id="img-copy-press-subdomain"
              body={toolTipTextPress}
              hintClassNames={"img-copy-store"}
            >
              <button
                data-button-type="secondary"
                data-icon
                data-icon-only
                onClick={async () => {
                  await copy(pressUrl);
                  copyText("press");
                }}
                type="button"
              >
                <img src="/img/new-icons/copy.svg" alt="copy" />
              </button>
            </ToolTip>
          </div>
        </li>
      </ul>
    </details>
  );
};
class View extends React.PureComponent {
  constructor(props, context) {
    super(props, context);

    const initialtab = context.locals.query.storeType;

    this.state = {
      showAccountLinkVideo: false,
      showSortCategories: false,
      showSortableMenu: false,
      draggin: false,
      sortableLoaded: false,
      selectedCategoryIndex: null,
      showMostPopular: false,
      toolTipText: "copyToClipboard",
      toolTipTextEmail: "copyToClipboard",
      toolTipTextPassword: "copyToClipboard",
      toolTipTextPress: "copyToClipboard",
      openedStoreDropdown: false,
      currentTab: initialtab || "programs",
    };
    this.sortable = null;
    this.accountLinkVideo = this.accountLinkVideo.bind(this);
    this.loadDraggable = this.loadDraggable.bind(this);
    this.selectCategory = this.selectCategory.bind(this);
    this.toggleMostPopular = this.toggleMostPopular.bind(this);
    this.deleteCategory = this.deleteCategory.bind(this);
    this.toggleSortable = this.toggleSortable.bind(this);
    this.handleSort = this.handleSort.bind(this);
    this.copyText = this.copyText.bind(this);
  }

  componentDidMount() {
    // This flash error will be shown for now to the users trying to access
    // to the store from a mobile device, because the design is not ready yet
    // check athletes.controller.js
    if (window?.innerWidth <= 960) {
      submit("/coaching-portal/athletes", {
        body: {
          flashError: this.props.t("store.responsiveNotAvailable"),
        },
      });
    }

    const { activeUser, query } = this.context.locals;

    if (query.stripeAccountLinkReturn) {
      submit("/actions/user/finish-account-link", { method: "POST" });
    } else if (
      activeUser.pushAccountInfo &&
      !activeUser.pushAccountInfo.accountLinkFinished
    )
      this.setState({ showAccountLinkVideo: true });
    if (this.context.locals.query.status === "draft") return;
    this.loadDraggable();
  }

  componentDidUpdate() {
    if (
      this.context.locals.query.status === "draft" &&
      this.sortable !== null
    ) {
      this.sortable.destroy();
      this.sortable = null;
    }

    if (
      this.context.locals.query.status === "published" &&
      this.sortable === null
    ) {
      this.loadDraggable();
    }
  }

  componentWillUnmount() {
    if (this.sortable) {
      this.sortable.destroy();
      this.sortable = null;
    }
  }

  loadDraggable() {
    scriptLoader(
      "https://cdn.jsdelivr.net/npm/sortablejs@1.15.7/Sortable.min.js",
      () => {
        const dragImage = document.createElement("img");
        dragImage.src =
          "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7";
        this.sortable = new Sortable(document.querySelector("#drag-items"), {
          animation: 350,
          filter: ".button-card",
          setData(dataTransfer) {
            dataTransfer.setDragImage(dragImage, 0, 0);
          },
          onStart: () => {},
          onEnd: ({ oldIndex, newIndex }) => {
            if (oldIndex === newIndex) return;
            const reorderedCycles = [];
            const programs = document.querySelectorAll(".column");
            programs.forEach((program) => {
              reorderedCycles.push(program.id);
            });
            submit("/actions/cycle/store/reorder", {
              method: "POST",
              body: {
                orderedCycles: reorderedCycles,
              },
            });
          },
        });
        this.setState({
          sortableLoaded: true,
        });
      }
    );
  }

  copyText(type) {
    if (type === "email") {
      this.setState({
        toolTipTextEmail: "copied",
        toolTipText: "copyToClipboard",
        toolTipTextPassword: "copyToClipboard",
        toolTipTextPress: "copyToClipboard",
      });
      setTimeout(() => {
        this.setState({ toolTipTextEmail: "copyToClipboard" });
      }, 30000);
    } else if (type === "password") {
      this.setState({
        toolTipTextPassword: "copied",
        toolTipTextEmail: "copyToClipboard",
        toolTipText: "copyToClipboard",
        toolTipTextPress: "copyToClipboard",
      });
      setTimeout(() => {
        this.setState({ toolTipTextPassword: "copyToClipboard" });
      }, 30000);
    } else if (type === "press") {
      this.setState({
        toolTipTextPress: "copied",
        toolTipText: "copyToClipboard",
        toolTipTextPassword: "copyToClipboard",
        toolTipTextEmail: "copyToClipboard",
      });
      setTimeout(() => {
        this.setState({ toolTipTextPress: "copyToClipboard" });
      }, 30000);
    } else {
      this.setState({
        toolTipText: "copied",
        toolTipTextPassword: "copyToClipboard",
        toolTipTextEmail: "copyToClipboard",
        toolTipTextPress: "copyToClipboard",
      });
      setTimeout(() => {
        this.setState({
          toolTipText: "copyToClipboard",
        });
      }, 30000);
    }
  }

  accountLinkVideo() {
    const generateLink = () => {
      submit("/actions/user/generate-account-link", {
        method: "POST",
      });
    };

    return (
      <ConnectedAccountModal
        onClose={() => {
          this.setState({ showAccountLinkVideo: false });
        }}
        generateLink={generateLink}
        context={this.context}
      />
    );
  }

  handleSort(direction = "up") {
    try {
      if (direction === "custom") {
        this.openCustomSort();
        return;
      }
      const { programCategories } = this.props;
      const sortedCategories = Array.from(programCategories).sort();
      if (direction !== "up") sortedCategories.reverse();
      const { activeUserToRequest } = this.context.locals;
      submit(`/actions/cycle/store/sort-category`, {
        method: "POST",
        body: {
          sortedCategories,
          activeUserToRequestId: activeUserToRequest._id,
        },
      });
    } catch (error) {
      console.error("Error in handleSort:", error);
    }
  }

  filterCategoryPrograms(programs) {
    const {
      locals: {
        query: { category },
      },
    } = this.context;
    const { showMostPopular, currentTab } = this.state;
    const { programCategories } = this.props;
    if (!category && !showMostPopular) return programs;
    const isUncategorized = category === "Uncategorized";
    if (isUncategorized && !showMostPopular)
      return programs.filter(
        (program) =>
          !program.category || !programCategories.includes(program.category)
      );

    const { mostPopular, mostPopularSingle } = this.props;

    const filtering = showMostPopular
      ? programs.find(
          (program) =>
            program._id ===
            (currentTab === "programs" ? mostPopular : mostPopularSingle)
        )
      : programs.filter((program) => {
          return program.category === category;
        });
    // Avoid errors if no most popular program is found
    return showMostPopular ? (filtering ? [filtering] : []) : filtering;
  }

  toggleSortable() {
    this.setState((prevState) => ({
      showSortableMenu: !prevState.showSortableMenu,
    }));
  }

  openCustomSort() {
    submit("/actions/refresh?", {
      method: "GET",
      body: {
        "modal[type]": "sort-categories",
      },
    });
  }

  toggleMostPopular() {
    this.setState((prevState) => ({
      showMostPopular: !prevState.showMostPopular,
    }));
  }

  addCategory() {
    submit("/actions/refresh?", {
      method: "GET",
      body: {
        "modal[type]": "manage-categories",
        newCategory: true,
      },
    });
  }

  selectCategory(selectedCategoryIndex, category) {
    this.setState({
      showSortableMenu: false,
      selectedCategoryIndex,
      showMostPopular: false,
    });

    submit("/actions/refresh?", {
      method: "GET",
      body: {
        selectedCategoryIndex,
        category,
      },
    });
  }

  deleteCategory(categoryIndex) {
    const confirm = window.confirm(
      this.props.t("store.manageCategories.deleteConfirm")
    );
    if (!confirm) return;
    submit(`/actions/cycle/store/manage-category/${categoryIndex}`, {
      method: "GET",
    });
  }

  render() {
    const { t } = this.props;
    const { locals } = this.context;
    const { programCategories } = this.props;
    const {
      showAccountLinkVideo,
      showSortableMenu,
      showMostPopular,
      toolTipText,
      toolTipTextPress,
      currentTab,
    } = this.state;
    const {
      storePrograms,
      activeUserToRequest,
      query: { category, selectedCategoryIndex, status },
      activeUser,
    } = locals;

    const { pushAccountInfo, pressAccountInfo } = activeUserToRequest;

    const pushSubdomain = pushAccountInfo.subdomain;
    const pushStorefrontUrl = `https://${pushSubdomain}.programs.app`;
    const pressStorefrontUrl = `https://${pushSubdomain}.gymmembership.app`;
    const hasPressStorefront =
      Boolean(pressAccountInfo) && Boolean(pushSubdomain);

    let lastPushed = storePrograms.published.length
      ? (new Date() - storePrograms.published[0].modifiedDate) /
        (1000 * 3600 * 24)
      : null;
    if (lastPushed)
      lastPushed =
        lastPushed < 1
          ? this.props.t("store.lastPushedLessThanOneDay")
          : this.props.t("store.lastPushedDays", {
              count: lastPushed.toFixed(),
            });

    const filteredPrograms = this.filterCategoryPrograms(
      storePrograms[locals.query.status || "published"].filter(
        (program) =>
          (currentTab === "programs" && !program.storeType) ||
          program.storeType === currentTab
      )
    );
    const hasDraftedPrograms =
      storePrograms.draft.filter(
        (program) =>
          (currentTab === "programs" && !program.storeType) ||
          program.storeType === currentTab
      ).length > 0;
    const hasPublishedPrograms =
      storePrograms.published.filter(
        (program) =>
          (currentTab === "programs" && !program.storeType) ||
          program.storeType === currentTab
      ).length > 0;

    const hasAdminPermission = activeUser?.organizationUserStatus
      ? locals?.organizationRoleName &&
        (locals.organizationRoleName === "Owner" ||
          locals.organizationRoleName === "Admin")
      : true;

    return (
      <main className="coaching-store">
        {showAccountLinkVideo && this.accountLinkVideo()}
        <header>
          <hgroup>
            <div className="flex gap-2 grow">
              <div className="toggle-options">
                <a
                  role="button"
                  data-button-type={
                    status === "published" || status === undefined
                      ? "outline"
                      : "text-white"
                  }
                  href="/actions/refresh?status=published"
                >
                  <span>{t("store.published")}</span>
                </a>
                <a
                  role="button"
                  data-button-type={
                    status === "draft" ? "outline" : "text-white"
                  }
                  href="/coaching-portal/store?status=draft"
                >
                  <span>{t("store.draft")}</span>
                </a>
              </div>
              <nav role="tablist">
                <a
                  aria-current={currentTab === "programs" ? true : undefined}
                  onClick={() => {
                    this.setState({ currentTab: "programs" });
                  }}
                >
                  {t("store.programs")} (
                  {
                    storePrograms[locals.query.status || "published"].filter(
                      (program) =>
                        !program.storeType || program.storeType === "programs"
                    ).length
                  }
                  )
                </a>
                <a
                  aria-current={currentTab === "teams" ? true : undefined}
                  onClick={() => {
                    this.setState({ currentTab: "teams" });
                  }}
                >
                  {t("store.teams")} (
                  {
                    storePrograms[locals.query.status || "published"].filter(
                      (program) => program.storeType === "teams"
                    ).length
                  }
                  )
                </a>
                <a
                  aria-current={
                    currentTab === "single-workout" ? true : undefined
                  }
                  onClick={() => {
                    this.setState({ currentTab: "single-workout" });
                  }}
                >
                  {t("store.singleWorkouts")} (
                  {
                    storePrograms[locals.query.status || "published"].filter(
                      (program) => program.storeType === "single-workout"
                    ).length
                  }
                  )
                </a>
              </nav>
            </div>

            <div className="flex gap-2">
              <a
                role="button"
                data-button-type={"outline"}
                href="/coaching-portal/store/program-metrics"
                className="program-metrics mobile-hidden gap-2"
              >
                <SvgIcon
                  src={`/img/new-icons/vuesax-linear-chart.svg`}
                  useCurrentColor={true}
                  style={{
                    width: "1.5rem",
                    height: "1.5rem",
                    backgroundColor: "transparent",
                    backgroundImage: "var(--primary-background-color)",
                    backgroundSize: "9rem 100%",
                    backgroundRepeat: "no-repeat",
                    backgroundPosition: "left center",
                    backgroundClip: "border-box",
                    WebkitBackgroundClip: "border-box",
                  }}
                />
                <span
                  style={{
                    backgroundImage: "var(--primary-background-color)",
                    backgroundSize: "9rem 100%",
                    backgroundRepeat: "no-repeat",
                    backgroundPosition: "calc(-1.5rem - 0.53rem) center",
                    backgroundClip: "text",
                    WebkitBackgroundClip: "text",
                    color: "transparent",
                  }}
                >
                  {t("store.programMetrics")}
                </span>
              </a>
              {hasPressStorefront ? (
                <StorefrontLinks
                  state={this.state}
                  setState={(toset) => this.setState(toset)}
                  pushUrl={pushStorefrontUrl}
                  pressUrl={pressStorefrontUrl}
                  pushSubdomain={pushSubdomain}
                  copyText={this.copyText}
                  toolTipTextPush={t(`store.${toolTipText}`)}
                  toolTipTextPress={t(`store.${toolTipTextPress}`)}
                  t={t}
                />
              ) : (
                <a
                  role="button"
                  data-button-type="outline"
                  data-icon
                  href={pushStorefrontUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="gap-2"
                >
                  <SvgIcon src="/img/new-icons/export.svg" />
                  {t("store.storefrontLinks.pushStorefront")}
                </a>
              )}
              <DropdownIconsCheck
                items={[
                  {
                    title: t("store.sortAZ"),
                    alt: t("store.sortAlt"),
                    id: "up",
                  },
                  {
                    title: t("store.sortZA"),
                    alt: t("store.sortAlt"),
                    id: "down",
                  },
                  {
                    title: t("store.sortCustom"),
                    alt: t("store.sortAlt"),
                    id: "custom",
                  },
                ]}
                action={this.handleSort}
                title={t("store.sort")}
              />
              {hasAdminPermission && (
                <a
                  href="/coaching-portal/settings/branding"
                  role="button"
                  data-button-type="outline"
                >
                  {t("store.editBranding")}
                </a>
              )}

              <a
                role="button"
                data-button-type="primary"
                href={`/actions/refresh/?modal[type]=build-step-one&cycleType=new&isSubscription=true&storeType=${currentTab}`}
              >
                <img alt={t("store.addAlt")} src="/img/new-icons/add.svg" />
                {t("store.addNew")}
              </a>
            </div>
          </hgroup>
          <SubHeader
            lastPushed={lastPushed}
            storePrograms={storePrograms}
            programCategories={programCategories}
            showSortableMenu={showSortableMenu}
            showMostPopular={showMostPopular}
            selectedCategoryIndex={selectedCategoryIndex}
            toggleSortable={this.toggleSortable}
            selectCategory={this.selectCategory}
            handleSort={this.handleSort}
            openCustomSort={this.openCustomSort}
            toggleMostPopular={this.toggleMostPopular}
            addCategory={this.addCategory}
          />
        </header>

        {category &&
        (selectedCategoryIndex || typeof selectedCategoryIndex === "number") &&
        !this.state.showMostPopular ? (
          <ManageCategories
            category={category}
            selectedCategoryIndex={selectedCategoryIndex}
            filteredProgramsLength={filteredPrograms.length}
            deleteCategory={this.deleteCategory}
            currentTab={currentTab}
          />
        ) : null}
        <section>
          <div
            className={`columns ${status === "draft" ? "draft" : ""}`}
            id="drag-items"
          >
            {filteredPrograms.length > 0 ? (
              map(filteredPrograms, (cycle, cardIndex) => {
                return (
                  <CycleCard
                    key={cycle._id}
                    cycle={cycle}
                    cardIndex={cardIndex}
                    isOwnCycle={cycle.owner === locals.activeUserToRequest._id}
                  />
                );
              })
            ) : (
              <EmptyStoreState
                category={category}
                currentTab={currentTab}
                status={status || "published"}
                hasDraftedPrograms={hasDraftedPrograms}
                hasPublishedPrograms={hasPublishedPrograms}
              />
            )}
          </div>
          <input
            type="radio"
            name="more"
            id="more-reset"
            style={{ display: "none" }}
          />
        </section>
      </main>
    );
  }
}

View.contextType = RillContext;

export default withTranslation("coaching-portal")(View);
